import React from 'react'

interface Props {
	position: number
	total: number
	text: string
}

const EnodeInitHeader: React.FC<Props> = ({ position, total }) => {
	return (
		<div className='py-2 px-3 rounded-xl text-xl font-semibold w-fit h-fit tracking-widest dark:text-brand-primary-200-dark dark:bg-brand-secondary-100-dark bg-brand-secondary-200-light text-brand-primary-100-light'>
			{position}/{total}
		</div>
	)
}

export default EnodeInitHeader
